import { useState } from "react";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
function f() {
  var t;
  let [e] = useState(() => typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = useState((t = e == null ? void 0 : e.matches) != null ? t : false);
  return n(() => {
    if (!e) return;
    function n2(r) {
      c(r.matches);
    }
    return e.addEventListener("change", n2), () => e.removeEventListener("change", n2);
  }, [e]), o;
}
export {
  f as useIsTouchDevice
};
